<template>
  <div class="wrapper">
    <div class="inner">
      <div v-if="token" class="grid">
        <div class="grid__item grid__item_50"></div>
        <div class="grid__item grid__item_50 data_input">
          <div class="title">
            <h1>Thiết lập lại mật khẩu</h1>
          </div>
          <div class="content_input">
            <b-field label="Mật khẩu mới">
              <b-input
                type="password"
                placeholder="Nhập mật khẩu mới của bạn"
                v-model="new_password"
                @input="checkpassword"
                password-reveal
              >
              </b-input>
            </b-field>
            <div v-if="checkerror == true" style="margin-bottom: 10px;">
              <span style="color:#ff0c00">{{ checkerrorText }}</span>
            </div>
            <b-field label="Nhập lại mật khẩu mới">
              <b-input
                placeholder="Nhập lại mật khẩu mới của bạn"
                type="password"
                v-model="new_password1"
                @input="checkpasswordagain"
              >
              </b-input>
            </b-field>
            <div v-if="checkerror1 == true" style="margin-bottom: 10px;">
              <span style="color:#ff0c00">{{ checkerrorText1 }}</span>
            </div>
            <div
              v-if="
                new_password.length > 0 &&
                  new_password1.length > 0 &&
                  checkerror == false &&
                  checkerror1 == false
              "
              class="btn_"
            >
              <a href="javascript:void(0)" @click="resetPassword()">Gửi</a>
            </div>
            <div class="disibale btn_" v-else>
              <a href="javascript:void(0)" @click="checktest()">Gửi</a>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="grid">
        <div class="grid__item grid__item_50"></div>
        <div class="grid__item grid__item_50 data_input">
          <div class="title">
            <h1>Thiết lập lại mật khẩu</h1>
          </div>
          <div class="content_input">
            <span>Bạn đã có thể dùng mật khẩu mới để đăng nhập</span>
          </div>
        </div>
      </div>
      <b-modal :active.sync="showsuccess" :width="500" scroll="keep">
        <div class="card succes">
          <h2>Thiết lập mật khẩu</h2>
          <span>{{ textdata }}</span>
          <div class="btn1_">
            <a href="javascript:void(0)" @click="showsuccess = false">Đóng</a>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { HTTP } from "../httpService/http-common";
import "../style.css";
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      new_password: "",
      new_password1: "",
      checkerror: false,
      checkerrorText: "",
      checkerror1: false,
      checkerrorText1: "",
      token: null,
      showsuccess: false,
      textdata: ""
    };
  },
  created() {
    var searchParams3 = new URLSearchParams(window.location.search);
    this.token = searchParams3.get("token");
    console.log(this.token);
  },
  methods: {
    checkpassword() {
      if (this.new_password && this.new_password.length < 8) {
        this.checkerror = true;
        this.checkerrorText = "* Mật khẩu phải có ít nhất 8 kí tự";
      } else {
        this.checkerror = false;
      }
    },
    checkpasswordagain() {
      if (this.new_password1 != this.new_password) {
        this.checkerror1 = true;
        this.checkerrorText1 = "* Mật khẩu không khớp , vui lòng nhập lại";
      } else {
        this.checkerror1 = false;
      }
    },
    checktest() {
      if (this.new_password == "" && this.new_password1 == "") {
        this.checkerror = true;
        this.checkerror1 = true;
        this.checkerrorText = "* Mật khẩu không được để trống";
        this.checkerrorText1 = "* Mật khẩu không được để trống";
      }
    },
    async resetPassword() {
      await HTTP.post("/auth/customer/reset_password", {
        token: this.token,
        password: this.new_password
      })
        .then(data => {
          this.token = "";
          location.href = location.href.split("?")[0];
          console.log(location.href.split("?")[0]);
          this.showsuccess = true;
          this.textdata = "Mật Khẩu của bạn đã được thiết lập thành công";
        })
        .catch(error => {
          this.showsuccess = true;
          this.textdata = error.response.data.message;
        });

      return;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue